import { render, staticRenderFns } from "./NoFlatPlug.vue?vue&type=template&id=1178feb4&lang=pug&"
import script from "./NoFlatPlug.vue?vue&type=script&lang=ts&"
export * from "./NoFlatPlug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports